import PropTypes from "prop-types";
import React from "react";
import MDBox from "../../MDBox";
import MDInput from "../../MDInput";
import GenericQuizExecutor from "../../GenericQuiz/executor.js";
import ValidationHint from "../../GenericQuiz/validation-hint.js";
import { PRONOUNS, PRONOUNS_SHORT, getTenseLabel } from "./data.js";

function Executor(props) {
  return (
    <GenericQuizExecutor {...props} activityEndpoint={"conjugation"}>
      {({ question, answer, onAnswerChange, valid, validAnswer, submit }) => (
        <>
          <MDBox sx={{ fontSize: "2rem", mb: 2, color: "#577ab4", lineHeight: "1" }}>
            Conjugue{" "}
            <MDBox sx={{ fontWeight: "bold" }} component="span">
              {question.verb}
            </MDBox>{" "}
            {getTenseLabel(question.tense).startsWith("I") ? "à l'" : "au "}
            <MDBox sx={{ textDecoration: "underline" }} component="span">
              {getTenseLabel(question.tense).toLowerCase()}
            </MDBox>
            {question.pronoun || question.pronoun === 0 ? ", " + PRONOUNS[question.pronoun] : ""} :
          </MDBox>
          <MDBox display="flex" alignItems="center" sx={{ fontSize: "2.2rem", "& > *": { mr: 1 } }}>
            {(question.pronoun || question.pronoun === 0) && (
              <span>{PRONOUNS_SHORT[question.pronoun]}</span>
            )}
            <MDInput
              type="text"
              name="answer"
              value={answer || answer === 0 ? answer : ""}
              onChange={onAnswerChange}
              onKeyUp={(e) => {
                if (e.keyCode === 13) {
                  submit();
                }
              }}
              readOnly={valid > 0}
              success={valid === 1}
              error={valid === 2 || valid < 0}
              focused={true}
              sx={{
                "& .MuiInputBase-input": { fontSize: "2.2rem", width: 150, textAlign: "center" },
              }}
            />
          </MDBox>
          {/* TODO : build a more complex good answer (radical + termination -- compound tenses) */}
          <ValidationHint valid={valid} validAnswer={validAnswer} />
        </>
      )}
    </GenericQuizExecutor>
  );
}
Executor.propTypes = {
  params: PropTypes.object,
  onEnd: PropTypes.func,
};

export default Executor;
